<template>
  <div class="labels" 
    v-if="product && (product.labels && product.labels.length)"
  >
    <div class="list">
      <ul>
        <li 
          v-show="(!moreopen && index > 2) ? false : true"
          v-for="(label, index) in product.labels"
          class="label" 
          v-bind:class="{'invalid' : !label.valid }"
          @click="jump(label)" >
          <span class="summary" v-bind:style="{ color: label.summaryColor }">
            <div class="tg">
              <span class="type" v-bind:style="{ color: label.typeColor, backgroundColor:  label.typeBgColor}" >{{label.type}}</span>
            </div>
 
            <span class="sm" v-if="label.summary">{{label.summary}}</span>
            <div class="line"></div>
          </span>
          <span v-if="label.count" class="count">x{{label.count}}</span>
          <i class="arrow"></i>
        </li>
      </ul>
    </div>
    <div class="more" v-if="product.labels.length > 3">
      <div class="" v-if="!moreopen" @click="showLabelMore">查看其他{{product.labels.length - 3}}个活动<i></i></div>
      <div class="" v-else @click="showLabelMore">收起<i class="up"></i></div>
    </div>
  </div>
</template>

<script>
import Labels from '@/labels/index'

export default {
  props: ['product'],

  components: {
    Labels
  },

  data () {
    return {
      moreopen: false
    }
  },

  methods: {
    showLabelMore () {
      this.moreopen = !this.moreopen
    },

    jump (label) {
      let title = ''

      if (label.campaign) {
        title = label.campaign.name
      }
      window.location.href = `${label.link}&showCampaign=true`
      // window.location.href = `${label.link}&title=${encodeURIComponent(title)}&showCampaign=true`
    }
  }
}
</script>




// WEBPACK FOOTER //
// labels.vue?9520fea4